export const CONTACT_LENS_GROUP_ID = 'contact_lenses'
